import React from 'react';
import ProjectsCards from '../ProjectsCards/ProjectsCards.jsx';
import projects from '../../info/projects.js';
import styles from './ProjectsContainer.module.css';

const ProjectsContainer = () => {
     return (
          <div id="projects" className={styles.container}>
               <div className={styles.title_container}>
                    <p data-aos="fade-right" className={styles.title}>
                         PROJECTS
                    </p>
                    <div data-aos="fade-right" data-aos-delay="50" className={styles.line_pc}></div>
                    <div
                         data-aos="fade-right"
                         data-aos-delay="50"
                         data-aos-anchor-placement="top-center"
                         className={styles.line_mobile}
                    ></div>
               </div>
               <div className={styles.projects_container}>
                    {projects.map((data) => {
                         return (
                              <ProjectsCards
                                   key={data.name}
                                   id={data.name}
                                   name={data.name}
                                   img={data.img}
                                   technologys={data.technologys}
                                   description={data.description}
                                   link={data.link}
                                   delay={data.delay}
                              />
                         );
                    })}
               </div>
          </div>
     );
};

export default ProjectsContainer;
